export default __webpack_public_path__ + "img/send.3a2f666c.svg";